import React, { createContext, useContext, useMemo, useState } from "react";

const emptyGlobal = {
  props: {},
};

const defaultValue = {
  ...emptyGlobal,
};

interface GlobalProviderProps {
  children: React.ReactNode;
}

const GlobalContext = createContext(defaultValue);

const GlobalProvider = ({ children }: GlobalProviderProps) => {
  const [globalProps, setGlobalProps] = useState(emptyGlobal);

  const value = useMemo(() => ({ ...globalProps }), [globalProps]);

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
};

GlobalProvider.defaultProps = {};

const useGlobal = () => useContext(GlobalContext);

export { GlobalProvider, useGlobal };
